// action - state management
import {
  GET_ALL_PORTFOLIO,
  GET_PORTFOLIO_DETAIL,
  GET_ALL_DROPDOWN,
  GET_IMAGE_URL,
  REMOVE_PORTFOLIO_DETAILS,
} from "./actions";

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
  portfolio_List: {},
  portfolio_Details: {},
  account_dropdown: [],
  category_dropdown: [],
  iamge_url: "",
  loading: true,
  detail_loading: true,
};

// const portfolioReducer = (state = initialState, action) => {
export const portfolioReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_PORTFOLIO:
      return {
        ...state,
        portfolio_List: payload,
        loading: false,
      };
    case GET_PORTFOLIO_DETAIL:
      return {
        ...state,
        portfolio_Details: payload,
        detail_loading: false,
      };
    case GET_ALL_DROPDOWN:
      return {
        ...state,
        account_dropdown: payload.account,
        category_dropdown: payload.category,
      };
    case GET_IMAGE_URL:
      return {
        ...state,
        iamge_url: payload,
      };
    case REMOVE_PORTFOLIO_DETAILS:
      return {
        ...state,
        portfolio_Details: {},
        detail_loading: false,
      };

    default:
      return state;
  }
};

export default portfolioReducer;
